module.exports = __webpack_public_path__ + "media/images/turbochargers/Top_Turbocharger-ff60b541ac93399fec31b736d0f21590.jpg";